import React from "react";

export const LazyCaseTagMultiSelect = React.lazy(() =>
    import(
        /* webpackChunkName: "caseTagMultiSelect" */ "./CaseTagMultiSelect"
    ).then(x => ({
        default: x.CaseTagMultiSelect
    }))
);
